import React from 'react';
import styled, { css } from 'styled-components';
import GfxImage from 'components/GfxImage';
import type { Maybe } from '.tina/__generated__/types';

interface TinaAssetStyles {
  mobileborderradius?: number;
  desktopborderradius?: number;
  $horizontalPaddingMobile?: boolean;
}
const Image = styled(GfxImage)<TinaAssetStyles>`
  width: 100%;
  height: 100%;
  padding: ${({ $horizontalPaddingMobile }) => $horizontalPaddingMobile && '0 1.5rem'};
  ${({ theme, $maxHeightMobile }) =>
    $maxHeightMobile &&
    theme.mq.ltLg`
    max-height: 100vh;
    flex: 0; 
    margin: 0 auto;
  `}
  ${({ theme }) => theme.mq.md`
    padding: 0;
  `}
  /* desktop only need >= 0, cause if not we would simply take the border radius from mobile.
Mobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */
  ${({ theme: { mq }, mobileborderradius, desktopborderradius }) =>
    css`
      ${`border-radius: ${mobileborderradius ? mobileborderradius : 16}px;`}
      ${mq.md`
        border-radius: ${desktopborderradius ? desktopborderradius : 24}px;
      `}
    `}
`;

export type TinaAsset = {
  asset?: Maybe<{
    src?: Maybe<string>;
    priority?: Maybe<boolean>;
    placeholder?: Maybe<string>;
    blurDataURL?: Maybe<string>;
    objectFit?: Maybe<string>;
    width?: Maybe<number>;
    height?: Maybe<number>;
    quality?: Maybe<number>;
    alt?: Maybe<string>;
    horizontalPadding?: Maybe<boolean>;
    maxHeightMobile?: Maybe<boolean>;
  }>;
  className?: string;
};

const TinaAsset: React.FC<TinaAsset> = ({ asset, className, ...props }) => {
  // do not render anything if no URL is provided
  if (!asset || !asset?.src) {
    return null;
  }

  // We don't want to apply either attribute if both conditions are not met
  const imageBlur = asset?.placeholder === 'blur' &&
    asset?.blurDataURL && {
      placeholder: asset?.placeholder as 'blur',
      blurDataURL: asset?.blurDataURL
    };

  const imageProps = {
    ...props,
    ...imageBlur
  };

  return (
    <Image
      {...imageProps}
      alt={asset?.alt || 'image description'}
      src={asset?.src || ''}
      priority={Boolean(asset?.priority)}
      quality={asset?.quality || 75}
      objectFit={(asset?.objectFit as 'none' | 'contain' | 'cover' | 'fill') || 'none'}
      className={className}
      $horizontalPaddingMobile={asset?.horizontalPadding ? true : undefined}
      $maxHeightMobile={asset?.maxHeightMobile ? asset?.maxHeightMobile : undefined}
      width={asset?.width || 0}
      height={asset?.height || 0}
    />
  );
};

export default styled(TinaAsset)``;
